export default "__VITE_ASSET__BAIt9Azg__"